import { Component } from '@angular/core';
import { OpenAIService } from './services/openAI.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('fadeInOut', [
      state('fade-in', style({ opacity: 1 })),
      state('fade-out', style({ opacity: 0 })),
      transition('fade-in <=> fade-out', animate('1s ease-in-out')),
    ]),
  ],
})
export class AppComponent {
  title = 'ChristmasWebsite';
  inputValue: string = '';
  waitState: string = 'fade-out';
  results: string = '';
  resultsState: string = 'fade-out';

  constructor(private openAIService: OpenAIService) {}

  checkCharacters(event: KeyboardEvent): void {
    const keyCode = event.keyCode;

    // Allow letters (A-Z, a-z) and the space key (keyCode 32)
    const isAllowedKey = (keyCode >= 65 && keyCode <= 90) ||
                         (keyCode >= 97 && keyCode <= 122 && keyCode !== 110) ||
                          keyCode === 32 || keyCode === 8 || keyCode === 46 || (keyCode >= 37 && keyCode <= 40);

    // Prevent the keypress if it's not allowed
    if (!isAllowedKey) {
      event.preventDefault();
    }
  }

  sendChatRequest(): void {
    const lettersRegex = /^[a-zA-Z\s]+$/;
    this.inputValue = this.inputValue.trim();
    if(this.inputValue.length > 0 && lettersRegex.test(this.inputValue)){
      this.results = '';
      const stringOptions: string[] = ['naughty', 'nice'];
      const randomIndex: number = Math.floor(Math.random() * 2);
      let randomlyChosenString: string = stringOptions[randomIndex];

      if(this.inputValue.toUpperCase().includes('COLTON')){
        randomlyChosenString = 'naughty';
      }
      this.waitState = 'fade-in';
      this.resultsState = 'fade-out';
      let prompt = 'Pretend you are Santa Claus and tell a kid named ' + this.inputValue.toUpperCase() + " that they are on Santa's " + randomlyChosenString + ' list';
      this.openAIService.sendRequest(prompt).subscribe(
        (response) => {
          console.log('API Response:', response);
          this.waitState = 'fade-out';
          this.results = response.choices[0].message.content;
          this.resultsState = 'fade-in';
        },
        (error) => {
          console.error('API Error:', error);

        }
      );
    }
  }
}
